import { useEffect, useState } from "react"
import { api } from "../../../../api/api"
import { Toast } from "../../../../utils/Toast"
import { SearchCep } from "../../../../services/cep"
import { useDispatch, useSelector } from "react-redux"
import { SET_COMPANY, UPDATE_COMPANY } from "../../../../stores/reducers/CompanyReducers"
import { FaHourglassStart, /**FaCopy**/ } from "react-icons/fa"
import { TbLink, TbWorldWww } from "react-icons/tb"
import { removeCaracteresEspeciais } from "../../../../utils/utils"
import ReactInputMask from "react-input-mask"
import { LIST_TYPE_COMPANY } from "../../../../utils/constantes"

export function Information() {
  const dispatch = useDispatch()
  const company = useSelector(state => state.company?.data)
  const [isAvailability, setIsAvailability] = useState(null)
  const [isCheckingLink, setIsCheckingLink] = useState(false)
  const [cpfOrCnpj, setCpfOrCnpj] = useState('cnpj')

  const cardapioBaseUrl = (process.env.REACT_APP_CARDAPIO || 'https://cardapio.unledu.com.br').replace(/\/$/, '')
  const linkPreview = `${cardapioBaseUrl}/${removeCaracteresEspeciais(company?.link)}`
  const domainPreview = (company?.domain || '').replace(/^https?:\/\//i, '').split('/')[0]


  useEffect(() => {
    setCpfOrCnpj(company?.cpfCnpj?.length <= 13 ? 'cpf' : 'cnpj')
  }, [company?.cpfCnpj])

  async function create() {
    await api.post('/companies', {
      ...company,
      timeDelivery: company.timeDelivery,
      timeRetirada: company.timeRetirada,
    })
    Toast.success()
  }

  function onChange(key, valueInput) {
    dispatch(SET_COMPANY({
      ...company,
      [key]: valueInput
    }))
  }

  function changePhonesRemoveCaracter(value = '') {
    return value
      .replace(/\(/ig, '')
      .replace(/\)/ig, '')
      .replace(/_/ig, '')
      .replace(/-/ig, '')
      .replace(/ /ig, '')
  }

  async function searchCep(valueCep) {
    try {
      const data = await SearchCep(valueCep)
      dispatch(UPDATE_COMPANY({
        ...company,
        ...data
      }))
    } catch (error) {
      Toast.warning("CEP inválido ou não encontrado.")
    }
  }

  async function checkLink() {
    if (!company?.link || isCheckingLink) return

    try {
      setIsCheckingLink(true)
      const response = await api.get('/companies/availability/' + encodeURIComponent(company.link))
      setIsAvailability(response.data)
    } finally {
      setIsCheckingLink(false)
    }
  }

  // function copy(url) {
  //   navigator.clipboard.writeText(url);
  //   Toast.success("Link copiado")
  // }

  return (
    <div className="mt-4 mb-4 company-panel company-information-panel">
      <h4 className="text-gray card-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '1.2rem' }}>
        Informações do Estabelecimento
      </h4>

      <div className="row">
        <div className="col-sm-7 mt-2">
          <label htmlFor="">Nome</label>
          <input className="form-control form-control-sm" type="text" value={company?.name ?? ''} onChange={(e) => onChange('name', e.target.value)} />
        </div>
        <div className="col-sm-2 mt-2">
          <label htmlFor="">Tipo de documento</label>
          <select className="form-select form-select-sm" value={cpfOrCnpj} onChange={(e) => {
            if (e.target.value === null || e.target.value === '---- Selecione ----')
              setCpfOrCnpj("cnpj")
            else
              setCpfOrCnpj(e.target.value)
          }}>
            <option value={null}>---- Selecione ----</option>
            <option value="cnpj">CNPJ</option>
            <option value="cpf">CPF</option>
          </select>
        </div>

        {cpfOrCnpj === 'cpf' &&
          <div className="col-sm-3 mt-2">
            <label htmlFor="">CPF</label>
            <ReactInputMask
              mask="999.999.999-99"
              className="form-control form-control-sm"
              value={company?.cpfCnpj ?? ''}
              onChange={(e) => onChange('cpfCnpj', e.target.value)}
            />
          </div>

        }
        {cpfOrCnpj === 'cnpj' &&
          <div className="col-sm-3 mt-2">
            <label htmlFor="">CNPJ</label>
            <ReactInputMask
              mask="99.999.999/9999-99"
              className="form-control form-control-sm"
              value={company?.cpfCnpj ?? ''}
              onChange={(e) => onChange('cpfCnpj', e.target.value)}
            />
          </div>
        }

        <div className="col-sm-4 mt-2">
          <label htmlFor="">Telefone</label>
          <ReactInputMask
            mask="(99) 9999-9999"
            className="form-control form-control-sm"
            value={company?.phone ?? ''}
            onChange={(e) => onChange('phone', changePhonesRemoveCaracter(e.target.value))}
          />
        </div>
        <div className="col-sm-4 mt-2">
          <label htmlFor="">Whatsapp</label>
          <ReactInputMask
            mask="+55 (99) 99999-9999"
            className="form-control form-control-sm"
            value={company?.whatsapp ?? ''}
            onChange={(e) => onChange('whatsapp', changePhonesRemoveCaracter(e.target.value))}
          />
        </div>
        <div className="col-sm-4 mt-2">
          <label htmlFor="">Área de atuação</label>
          <select value={company.area} onChange={(e) => {
            if (e.target.value === '-------- Selecione --------')
              onChange('area', null)
            else
              onChange('area', e.target.value)
          }} className="form-select form-select-sm" >
            <option value="">-------- Selecione --------</option>
            {LIST_TYPE_COMPANY.map(value => {
              return (
                <option key={value} value={value}>{value}</option>
              )
            })}
          </select>
        </div>
      </div>
      <div className="divider mt-4"></div>
      <h4 className="text-gray card-title mt-4" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '1.2rem' }}>
        Informações do Responsável
      </h4>

      <div className="row">
        <div className="col-sm-7 mt-2">
          <label htmlFor="">Nome</label>
          <input className="form-control form-control-sm" type="text" value={company?.nameResponsible ?? ''} onChange={(e) => onChange('nameResponsible', e.target.value)} />
        </div>
        <div className="col-sm-2 mt-2">
          <label htmlFor="">CPF</label>
          <input className="form-control form-control-sm" type="text" value={company?.cpfResponsible ?? ''} onChange={(e) => onChange('cpfResponsible', e.target.value)} />
        </div>
        <div className="col-sm-2 mt-2">
          <label htmlFor="">Telefone</label>
          <ReactInputMask
            mask="(99) 9 9999-9999"
            className="form-control form-control-sm"
            value={company?.phoneResponsible ?? ''} onChange={(e) => onChange('phoneResponsible', e.target.value)}
          />
        </div>
      </div>
      <div className="divider mt-4"></div>

      <h2 className="text-gray card-title mt-4" style={{ fontSize: '1.2rem' }}>Informações do Endereço</h2>
      <div className="row">
        <div className="col-sm-2 mt-2">
          <div>
            <label htmlFor="">CEP</label>
            <input className="form-control form-control-sm" type="text" value={company?.cep} onChange={async (e) => {
              onChange('cep', e.target.value)
              if (e.target.value.length === 8) {
                await searchCep(e.target.value)
              }
            }} />
          </div>
        </div>
        <div className="col-sm-5 mt-2">
          <label htmlFor="">Endereço</label>
          <input className="form-control form-control-sm" type="text" value={company?.address} onChange={(e) => onChange('address', e.target.value)} />
        </div>
        <div className="col-sm-2 mt-2">
          <label htmlFor="">Número</label>
          <input className="form-control form-control-sm" type="text" value={company?.number} onChange={(e) => onChange('number', e.target.value)} />
        </div>
        <div className="col-sm-3 mt-2">
          <label htmlFor="">Bairro</label>
          <input className="form-control form-control-sm" type="text" value={company?.district} onChange={(e) => onChange('district', e.target.value)} />
        </div>
        <div className="col-sm-3 mt-2">
          <label htmlFor="">Cidade</label>
          <input className="form-control form-control-sm" type="text" value={company?.city} onChange={(e) => onChange('city', e.target.value)} />
        </div>
        <div className="col-sm-1 mt-2">
          <label htmlFor="">UF</label>
          <input className="form-control form-control-sm" type="text" value={company?.uf} onChange={(e) => onChange('uf', e.target.value)} />
        </div>
      </div>

      <section className="admin-surface company-cardapio-section">
        <header className="admin-surface-header">
          <div>
            <h2>Endereço do cardápio</h2>
            <p>Escolha como seus clientes acessarão o cardápio online.</p>
          </div>
        </header>

        <div className="company-cardapio-grid">
          <section className="company-url-card">
            <div className="company-url-card-heading">
              <span><TbLink size={21} /></span>
              <div>
                <h3>Link padrão</h3>
                <p>É nome que irá aparecer no link que você envia para seu cliente. Geralmente usado o nome do estabelecimento.</p>
              </div>
            </div>

            <label htmlFor="companyLink">Identificador do link</label>
            <div className="company-url-input">
              <span>{cardapioBaseUrl}/</span>
              <input
                id="companyLink"
                className="form-control form-control-sm"
                type="text"
                placeholder="pizzaria_do_joao"
                value={removeCaracteresEspeciais(company?.link)}
                aria-describedby="companyLinkHelp companyLinkStatus"
                onChange={(e) => {
                  setIsAvailability(null)
                  onChange('link', removeCaracteresEspeciais(e.target.value))
                }}
              />
            </div>

            <div className="company-url-example" id="companyLinkHelp">
              <small>Seu endereço ficará assim:</small>
              <strong>{linkPreview}</strong>
            </div>

            <div className="company-link-check">
              <div id="companyLinkStatus" className="form-text" aria-live="polite">
                {isAvailability === null && <span>Consulte se este identificador está disponível.</span>}
                {isAvailability === true && <span className="text-success">Este link está disponível.</span>}
                {isAvailability === false && <span className="text-danger">Este link não está disponível.</span>}
              </div>
              <button
                type="button"
                className="btn btn-sm border company-secondary-btn"
                onClick={checkLink}
                disabled={!company?.link || isCheckingLink}
              >
                {isCheckingLink ? 'Consultando...' : 'Consultar disponibilidade'}
              </button>
            </div>
          </section>

          <section className="company-url-card company-custom-domain-card">
            <div className="company-url-card-heading">
              <span><TbWorldWww size={21} /></span>
              <div>
                <h3>Domínio personalizado</h3>
                <p>Substitui todo o endereço padrão por um domínio próprio da sua loja.</p>
              </div>
            </div>

            <label htmlFor="companyDomain">Seu domínio</label>
            <div className="company-domain-input">
              <span>https://</span>
              <input
                id="companyDomain"
                className="form-control form-control-sm"
                type="text"
                placeholder="pizzariadojoao.com.br"
                value={domainPreview}
                aria-describedby="companyDomainHelp"
                onChange={(e) => onChange('domain', e.target.value.replace(/^https?:\/\//i, '').replace(/\s/g, '').toLowerCase())}
              />
            </div>

            <div className="company-url-example">
              <small>Seu endereço personalizado ficará assim:</small>
              <strong>https://{domainPreview || 'pizzariadojoao.com.br'}</strong>
            </div>

            <div className="company-domain-notice" id="companyDomainHelp">
              Informe somente o domínio, sem <strong>https://</strong>. Depois, entre em contato com o suporte para concluir a ativação.
            </div>
          </section>
        </div>
      </section>

      <section className="admin-surface company-service-times-section">
        <header className="admin-surface-header">
          <div>
            <h2>Prazos de atendimento</h2>
            <p>Informe ao cliente o tempo médio para receber ou retirar um pedido.</p>
          </div>
        </header>
        <div className="company-service-times-grid">
          <div>
            <label htmlFor="timeDelivery">Tempo médio de entrega</label>
            <div className="input-group">
              <span className="input-group-text" aria-hidden="true"><FaHourglassStart /></span>
              <input
                id="timeDelivery"
                className="form-control form-control-sm"
                type="number"
                min="0"
                max="999"
                value={company?.timeDelivery ?? ''}
                onChange={(e) => dispatch(SET_COMPANY({ ...company, timeDelivery: e.target.value }))}
              />
              <span className="input-group-text">minutos</span>
            </div>
          </div>
          <div>
            <label htmlFor="timeRetirada">Tempo médio de retirada</label>
            <div className="input-group">
              <span className="input-group-text" aria-hidden="true"><FaHourglassStart /></span>
              <input
                id="timeRetirada"
                className="form-control form-control-sm"
                type="number"
                min="0"
                max="999"
                value={company?.timeRetirada ?? ''}
                onChange={(e) => dispatch(SET_COMPANY({ ...company, timeRetirada: e.target.value }))}
              />
              <span className="input-group-text">minutos</span>
            </div>
          </div>
        </div>
      </section>

      <div className="divider mt-2 mb-4"></div>

      <div className="text-start">
        <button className="admin-primary-button" onClick={() => create()}>Salvar informações</button>
      </div>
    </div >
  )
}
